var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginwarn"},[_c('label',[_vm._v("为方便您购买，请提前登录")]),_vm._v(" "),_c('span',[_c('label',{staticStyle:{"color":"#F36F07","padding-right":"10px"}},[_vm._v("立即登录")]),_vm._v(" "),_c('i',{staticClass:"el-icon-close"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dc6e874","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/loginwarn.vue
// module id = null
// module chunks = 